import React, { useContext, useEffect } from "react";
import { AuthContext } from "../App";
import { useNavigate } from "react-router-dom";

function Logout() {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    localStorage.clear()
    navigate("/login");
  }, [logout, navigate]);

  return null;
}

export default Logout;
